import SuggestionList, { SuggestionListProps } from './SuggestionList';

export default SuggestionList;
export type { SuggestionListProps };
